export default __webpack_public_path__ + "static/media/help2.3cea0cf4.png";